module.exports = __webpack_public_path__ + "static/media/background.0af5f03c.jpg";